import { RootReducer } from '../rootReducer';

export const createErrorSelector = (action: string) => (state: RootReducer) => state.errors[action];
